import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import cx from '../../utils/classNames';
import styles from './SwipeableView.module.css';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const SwipeableView = ({ children, className, autoPlay = false, hasArrowButtons = false, }) => {
    const SwipeView = autoPlay ? AutoPlaySwipeableViews : SwipeableViews;
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = React.Children.count(children);
    const accentBase = getComputedStyle(document.documentElement)
        .getPropertyValue('--accent-base')
        .trim();
    const localTheme = createTheme({
        palette: {
            primary: {
                main: accentBase,
            },
        },
        overrides: {
            MuiMobileStepper: {
                root: {
                    background: 'transparent',
                    padding: 0,
                    position: 'absolute',
                    left: '50%',
                    bottom: 0,
                    transform: 'translate(-50%, 0)',
                },
            },
            MuiButton: {
                root: {
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
                sizeSmall: {
                    padding: 0,
                },
            },
        },
    });
    const handleStepChange = (step) => {
        setActiveStep(step);
    };
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    return (_jsxs("div", Object.assign({ className: cx(styles.root, className) }, { children: [_jsx(SwipeView, Object.assign({ className: styles.swipeContainer, axis: "x", index: activeStep, onChangeIndex: handleStepChange, enableMouseEvents: true }, { children: React.Children.map(children, (child, index) => Math.abs(activeStep - index) <= 2 ? child : null) }), void 0), _jsx(MuiThemeProvider, Object.assign({ theme: localTheme }, { children: _jsx(MobileStepper, { steps: maxSteps, position: "static", variant: "dots", activeStep: activeStep, nextButton: hasArrowButtons && (_jsx(Button, Object.assign({ size: "small", onClick: handleNext, disabled: activeStep === maxSteps - 1, disableTouchRipple: true }, { children: _jsx(KeyboardArrowRight, {}, void 0) }), void 0)), backButton: hasArrowButtons && (_jsx(Button, Object.assign({ size: "small", onClick: handleBack, disabled: activeStep === 0, disableTouchRipple: true }, { children: _jsx(KeyboardArrowLeft, {}, void 0) }), void 0)) }, void 0) }), void 0)] }), void 0));
};
export default SwipeableView;
